import * as log from './log';
import { isMedian } from './median';

let lastLoggedExternalId = null;

const getMedianOneSignal = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.Median?.onesignal || window.Median?.oneSignal || null;
};

export const loginToMedianOneSignal = (currentUser) => {
  try {
    if (!currentUser || !isMedian()) {
      return null;
    }

    const externalId = currentUser?.id?.uuid;

    if (!externalId || externalId === lastLoggedExternalId) {
      return null;
    }

    const oneSignal = getMedianOneSignal();

    if (!oneSignal || typeof oneSignal.login !== 'function') {
      return null;
    }

    oneSignal.login(externalId);
    lastLoggedExternalId = externalId;
  } catch (error) {
    log.error(error, 'median-onesignal-login-failed');
  }

  return null;
};

export const logoutFromMedianOneSignal = () => {
  try {
    lastLoggedExternalId = null;

    if (!isMedian()) {
      return null;
    }

    const oneSignal = getMedianOneSignal();

    if (!oneSignal || typeof oneSignal.logout !== 'function') {
      return null;
    }

    oneSignal.logout();
  } catch (error) {
    log.error(error, 'median-onesignal-logout-failed');
  }

  return null;
};
